import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteTaskModal = ({ show, onClose, task, onTaskDeleted }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    const authToken = localStorage.getItem("auth_token");
    setLoading(true);

    try {
      const response = await fetch(
        `https://loopsneller.com/api/tasks/${task.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        onTaskDeleted(task.id);
        onClose();
      } else {
        console.error("Delete failed:", data);
        alert("Failed to delete task.");
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      alert("Error deleting task.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      {task && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>Delete Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to delete the task{" "}
              <strong>{task.title}</strong>?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default DeleteTaskModal;
